import { AppLayoutHeaderWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Header/HeaderWrapper";
import { AppLayoutWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Wrapper";
import { AppLayoutHeaderDesktop } from "../../Desktop/Header/AppLayoutHeader";
import { AppLayoutInnerWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/InnerWrapper";
import { AppLayoutPageWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/PageWrapper";
import { AllRoutes } from "../../Shared/Navigation/routes/AllRoutes";
import { NavigationMenuItemsTablet } from "./NavigationMenuItems";
import { NavigationMenuItemTablet } from "@src/appV2/redesign/AppLayout/Desktop/Tablet/Navigation/MenuItem";
import { NavigationMenuSectionTitleTablet } from "@src/appV2/redesign/AppLayout/Desktop/Tablet/Navigation/MenuSectionTitle";
import { NavigationMenuItemsWrapperTablet } from "@src/appV2/redesign/AppLayout/Desktop/Tablet/Navigation/MenuItemsWrapper";
import { RecentlyViewedSectionTablet } from "./RecentlyViewedSection";
import { useNavigationTranslationLabels } from "../../Shared/Navigation/navigationMenu/translationLabels";

export interface AppLayoutTabletProps {
  admin: boolean;
  isAdmin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  userName: string;
  userId: string;
  logoutConfirm: () => void;
  renderStartPage: () => JSX.Element | null;
}

export function AppLayoutTablet(props: AppLayoutTabletProps) {
  const { admin, isAdmin, isWorker, isWorkplace, logoutConfirm, renderStartPage } = props;
  const translationLabels = useNavigationTranslationLabels();

  return (
    <AppLayoutWrapperDesktop>
      <AppLayoutHeaderWrapperDesktop>
        <AppLayoutHeaderDesktop />
      </AppLayoutHeaderWrapperDesktop>
      <AppLayoutInnerWrapperDesktop>
        <NavigationMenuItemsWrapperTablet>
          <NavigationMenuItemsTablet
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
          />
          <RecentlyViewedSectionTablet admin={admin} />
          <NavigationMenuSectionTitleTablet>
            {translationLabels.logOut}
          </NavigationMenuSectionTitleTablet>
          <NavigationMenuItemTablet
            iconType="door-straight"
            isSelected={false}
            onClick={() => {
              logoutConfirm();
            }}
          >
            {translationLabels.logOut}
          </NavigationMenuItemTablet>
        </NavigationMenuItemsWrapperTablet>
        <AppLayoutPageWrapperDesktop>
          <AllRoutes
            admin={admin}
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
            renderStartPage={renderStartPage}
          />
        </AppLayoutPageWrapperDesktop>
      </AppLayoutInnerWrapperDesktop>
    </AppLayoutWrapperDesktop>
  );
}
